import {
  Outlet,
  ScrollRestoration,
  useLoaderData,
  useLocation,
  useRouteError,
} from "react-router-dom";
import NavigationBar from "../components/navigation-bar";
import PageFooter, {
  DEFAULT_FOOTER_LINKTREE_COUNT,
} from "../components/page-footer/index";
import ScrollToHash from "../utils/scroll-to-hash";
import GenericErrorDisplay from "./generic-error";
import useScrollPosition from "../hooks/useScrollPosition";
import ResourceService from "../service/resource";
import NewsService from "../service/news";
import LinktreeService from "../service/linktree";

const resourceKeys = {
  footerTitle: "footer-title",
  footerSubtitle: "address",
  facebookUrl: "facebook-url",
  instagramUrl: "instagram-url",
};

export async function loader({ request, params }) {
  const resources = new ResourceService().read.byIds(
    Object.values(resourceKeys)
  );
  const links = new LinktreeService().read.list(DEFAULT_FOOTER_LINKTREE_COUNT);
  const news = new NewsService().read.list(1, 4);
  return [await resources, await links, await news];
}

/**
 * This react component that specifies the general structure and layout of every page.
 * It uses the component 'Outlet' from react-router for the specific content of each page.
 *
 * @returns a react component to be used for the top-level 'Route' component of the router tree.
 */
function PageLayout() {
  const [resources, linktreeList, newsList] = useLoaderData();

  const scrollPosition = useScrollPosition();
  const location = useLocation();
  const navStyle = scrollPosition === 0 &&
    location.pathname === "/" && {
      height: 0,
      minHeight: 0,
      margin: 0,
      padding: 0,
      overflow: "hidden",
    };

  return (
    <>
      <NavigationBar style={navStyle} news={newsList} />
      <div
        style={{
          minHeight: "var(--nav-height  )",
          ...navStyle,
        }}
      />
      <Outlet />
      <PageFooter
        title={resources[resourceKeys.footerTitle]}
        subtitle={resources[resourceKeys.footerSubtitle]}
        facebookUrl={resources[resourceKeys.facebookUrl]}
        secondColumn={linktreeList}
        instagramUrl={resources[resourceKeys.instagramUrl]}
      />
      <ScrollRestoration />
      <ScrollToHash />
    </>
  );
}
export default PageLayout;

export function MainErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
